<template>
  <component
      :is="renderAs"
      :id="id"
      :class="(classList ? classList.toString() : '')"
      :to="renderAs !== 'button' ? href : undefined"
      :type="renderAs === 'button' ? type || 'button' : undefined"
      :rel="renderAs !== 'button' ? rel : undefined"
      :disabled="renderAs === 'button' ? isDisabled : undefined"
      :aria-disabled="renderAs !== 'button' && isDisabled ? 'true' : undefined"
      :target="renderAs !== 'button' ? target : undefined"
      :aria-label="ariaLabel || undefined"
      class="button"
      @click="click"
  >
    <span v-if="text" class="button-text">{{ text }}</span>
    <slot></slot>
    <span v-if="target === '_blank'" class="visually-hidden">(открывается в новой вкладке)</span>
  </component>
</template>

<script lang="ts" setup>
const props = defineProps<{
  id?: string,
  text?: string,
  href?: string,
  symbol?: string
  classList?: DOMTokenList | string
  target?: '_blank' | '_self' | '_parent' | '_top'
  isButton?: boolean
  type?: "button" | "submit" | "reset" | undefined,
  rel?: string,
  isDisabled?: boolean,
  ariaLabel?: string,
}>();

const nuxtLinkComponent = defineNuxtLink({})
const renderAs = computed(() => (props.isButton || !props.href) ? 'button' : nuxtLinkComponent)

function isScrollBtn(): boolean {
  if (typeof props.classList === 'object') {
    return props.classList.contains('js-scroll-anchor');
  } else if (typeof props.classList === 'string') {
    return /.*js-scroll-anchor.*/.test(props.classList);
  }

  return false;
}

const emit = defineEmits(['click'])

function click(e: MouseEvent) {
  if (renderAs.value !== 'button' && props.isDisabled) {
    e.preventDefault();
    return;
  }
  if (isScrollBtn()) {
    e.preventDefault();
    runScroll();
  } else {
    emit('click')
  }
}

function runScroll() {
  if (!props.href) return;
  const targetElement = document.querySelector(props.href) as HTMLElement | null;
  if (!targetElement) return;

  targetElement.scrollIntoView({block: "start", behavior: "smooth"});
}
</script>
